import RoomScore from './RoomScore.vue';
export default RoomScore;
